"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.log = exports.postWebkitMessage = void 0;

/*
 * File: Logging.js
 * Project: tsys-secure-entry
 *
 * Created by Jed Dumire on 07/09/2020
 *
 * Copyright (c) 2020 MacPractice, Inc. All rights reserved.
 *
 * Description: Logging and sending messages via webkit
 */

/**
 * Post a webkit message, used to communicate to MacPractice WKWebView
 *
 * @param {String} name
 * @param {any} body
 */
var postWebkitMessage = function postWebkitMessage(name, body) {
  if (window.webkit && window.webkit.messageHandlers[name]) {
    window.webkit.messageHandlers[name].postMessage(body);
  }
};
/**
 * If not in production, log information to console and via webkit message if available
 *
 * @param {any} message Message to log
 */


exports.postWebkitMessage = postWebkitMessage;

var log = function log(message) {
  if (process.env.NODE_ENV !== "production") {
    postWebkitMessage("log", message);
    console.log(message);
  }
};

exports.log = log;